import type { GlobalSearchIndexDTO } from '../core/models';

/** Fila de resultado con texto para el input (optionLabel). */
export type GlobalSearchHit = GlobalSearchIndexDTO & { displayLine: string };

/** Alcance de la búsqueda global (`all` = sin filtrar por tipo). */
export type GlobalSearchScope =
  | 'all'
  | 'Customer'
  | 'Product'
  | 'Sale'
  | 'SaleLink'
  | 'Subscription'
  | 'User'
  | 'Invoice'
  | 'Plan';

export type GlobalSearchScopeOption = {
  label: string;
  value: GlobalSearchScope;
  icon: string;
};

export const GLOBAL_SEARCH_SCOPE_OPTIONS: GlobalSearchScopeOption[] = [
  { label: 'Todos', value: 'all', icon: 'pi pi-sparkles' },
  { label: 'Clientes', value: 'Customer', icon: 'pi pi-users' },
  { label: 'Productos', value: 'Product', icon: 'pi pi-box' },
  { label: 'Planes', value: 'Plan', icon: 'pi pi-list' },
  { label: 'Ventas', value: 'Sale', icon: 'pi pi-shopping-cart' },
  { label: 'Enlaces', value: 'SaleLink', icon: 'pi pi-link' },
  { label: 'Suscripciones', value: 'Subscription', icon: 'pi pi-sync' },
  { label: 'Facturas', value: 'Invoice', icon: 'pi pi-file' },
  { label: 'Usuarios', value: 'User', icon: 'pi pi-user' }
];
